import { webApi } from "../../../../core/http/httpThunks";
import { EtfCompositionResponse } from "../types";

export const getEtfConpostitonApi = (userId: string, symbol: string, endpoint: string) => {
 // console.log("Poziva se getTradeApi sa:", { userId, divid });

  return webApi<EtfCompositionResponse>({
    method: "GET",
    url: "reporting/getsecurityinfo",
    params: {
      userId,
      symbol,
      endpoint
    },
  });
};

export default getEtfConpostitonApi;
